var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { get } from 'lodash-es';
import styled, { ThemeProvider } from 'styled-components';
import DoconDropdown from '../doconDropdown';
import { doconTheme } from "../../../theme/default";
var Root = styled(DoconDropdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute !important;\n  left: 0;\n  top: 100%;\n  width: 100%;\n\n  .reactSelect {\n\n    &__control {\n      height: 0;\n      min-height: 0;\n      overflow: hidden;\n      border: 0;\n    }\n\n    &__menu-list {\n      .reactSelect__option {\n        border-bottom: 1px solid ", ";\n\n        &--is-focused {\n          background-color: transparent;\n        }\n\n        &:hover {\n          background-color: var(--inp-bg-color);\n        }\n\n        &:last-child {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n"], ["\n  position: absolute !important;\n  left: 0;\n  top: 100%;\n  width: 100%;\n\n  .reactSelect {\n\n    &__control {\n      height: 0;\n      min-height: 0;\n      overflow: hidden;\n      border: 0;\n    }\n\n    &__menu-list {\n      .reactSelect__option {\n        border-bottom: 1px solid ", ";\n\n        &--is-focused {\n          background-color: transparent;\n        }\n\n        &:hover {\n          background-color: var(--inp-bg-color);\n        }\n\n        &:last-child {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n"])), doconTheme.v2.borderColor);
var Dropdown = React.forwardRef(function (_a, ref) {
    var menuIsOpen = _a.menuIsOpen, onClose = _a.onClose, props = __rest(_a, ["menuIsOpen", "onClose"]);
    var rootRef = useRef();
    var checkIfClickedOutside = function (e) {
        // If the menu is open and the clicked target is not within the menu,
        // then close the menu
        var menuListRef = (ref === null || ref === void 0 ? void 0 : ref.current) || get(rootRef, 'current.select.menuListRef');
        if (menuIsOpen && menuListRef.contains && !menuListRef.contains(e.target)) {
            onClose();
        }
    };
    useEffect(function () {
        document.addEventListener('mousedown', checkIfClickedOutside);
        return function () {
            // Cleanup the event listener
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [menuIsOpen]);
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Root, __assign({ ref: rootRef, isSkipValueFormatting: true, menuIsOpen: menuIsOpen, label: '' }, props))));
});
export default styled(Dropdown)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
